/**
 * The viewport while playing (reference 05): a border in the play color, the
 * game mode and the camera it's looking through, the zones as chips to jump
 * between (with auto-advance), and how to stop. Chips dispatch play commands;
 * the keyboard does the same through the shell's shortcuts.
 */
import { useEditor } from "../EditorContext";
import { useStore } from "../hooks/useStore";
import "./play.css";

export function PlayOverlay() {
  const { play, dispatch } = useEditor();
  const state = useStore(play);
  if (!state) return null;

  const run = (type: string, payload: object) => {
    void dispatch({ type, payload, origin: "viewport" });
  };
  const stop = state.stops[state.current];
  const keys = state.stops.length > 1 ? `1–${Math.min(state.stops.length, 9)} or ←/→ zones · ` : "";

  return (
    <div className="kn-play" data-paused={state.paused}>
      <div className="kn-play__mode">
        {state.mode}
        {stop && <span> · {stop.camera}</span>}
      </div>
      {state.stops.length > 0 && (
        <div className="kn-play__stops" role="toolbar" aria-label="Zones">
          {state.stops.map((zone, index) => (
            <button
              key={zone.id}
              type="button"
              className="kn-play__stop"
              aria-pressed={index === state.current}
              onClick={() => {
                run("play.goTo", { index });
              }}
            >
              {zone.label}
            </button>
          ))}
          <button
            type="button"
            className="kn-play__stop kn-play__auto"
            aria-pressed={state.autoAdvance}
            title="Auto-advance zones"
            onClick={() => {
              run("play.autoAdvance", { on: !state.autoAdvance });
            }}
          >
            Auto
          </button>
        </div>
      )}
      <div className="kn-play__hint">{keys}Esc stop</div>
    </div>
  );
}
